<template>
  <HeaderNav></HeaderNav>
  <div class="content">
    <router-view/>
   </div>
</template>

<style lang="scss">
@font-face {
    font-family: 'sourgummy';
    src: url('./assets/fonts/subset-SourGummy-ExtraLight.woff2') format('woff2'),
         url('./assets/fonts/subset-SourGummy-ExtraLight.woff') format('woff');
    font-weight: 200;
    font-style: normal;
}
@font-face {
    font-family: 'sourgummy';
    src: url('./assets/fonts/subset-SourGummy-Regular.woff2') format('woff2'),
         url('./assets/fonts/subset-SourGummy-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'barlow';
    src: url('./assets/fonts/subset-Barlow-Regular.woff2') format('woff2'),
         url('./assets/fonts/subset-Barlow-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

:root {
  --c-text: #2c3e50;
  --c-border: #767676;
  --c-yellow: #FFD166;
  --c-blue: #6EC1E4;
  --c-green: #4CAF50;
  --c-red: #fb2a48;
  --c-lightblue: #ddeffa;
}

#app {
  font-family: sourgummy, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--c-text);
}
body{
  margin:0;
  background: var(--c-lightblue);
}
html{
  font-size: 22px;
  @media (max-width: 767px) {
    font-size: 18px;
  }
}
a{color: var(--c-text);}
p{
  margin:0 0 0.5em;
}
h1{font-size:1.5em;}
input, button{font-family:inherit;}
button, .button{border: 1px solid var(--c-border); font-size: 22px; border-radius:3px; padding: 5px 16px; background: var(--c-yellow); color: #2c3e50; text-decoration: none; font-weight: 400;}
.content > *{width:800px; max-width:94%; margin: auto;}

</style>

<script>
import HeaderNav from '@/components/HeaderNav.vue'

export default {
  name: 'App',
  components: {
    HeaderNav
  }
}

</script>
